<template>
  <div class="center">
    <h2 class="title title--2 regular extra-spacing extra-spacing-top">
      Open<span class="bold">Tab</span>
    </h2>
    <div
      ref="carousel"
      class="carousel__items"
    >
      <div class="carousel__item">
        <div
          v-if="content.OpenTabOnboarding1.metadata.imageUrl"
          class="onboarding__image extra-spacing"
          :style="{ backgroundImage: `url('${content.OpenTabOnboarding1.metadata.imageUrl}')` }"
        />
        <div class="padding-x">
          <h2 class="title title--2">
            {{ content.OpenTabOnboarding1.title }}
          </h2>
          <p class="title title--4">
            {{ content.OpenTabOnboarding1.metadata.subtitle }}
          </p>
        </div>
      </div>
      <div class="carousel__item">
        <div
          v-if="content.OpenTabOnboarding2.metadata.imageUrl"
          class="onboarding__image extra-spacing"
          :style="{ backgroundImage: `url('${content.OpenTabOnboarding2.metadata.imageUrl}')` }"
        />
        <div class="padding-x">
          <h2 class="title title--2">
            {{ content.OpenTabOnboarding2.title }}
          </h2>
          <p class="title title--4">
            {{ content.OpenTabOnboarding2.metadata.subtitle }}
          </p>
        </div>
      </div>
    </div>
    <div class="padding-x">
      <div class="carousel__dots spacing">
        <div
          class="carousel__dot"
          :class="page === 1 && 'carousel__dot--active'"
        />
        <div
          class="carousel__dot"
          :class="page === 2 && 'carousel__dot--active'"
        />
      </div>
      <button
        type="button"
        class="button button--primary"
        @click="closeOpenTabOnboarding"
      >
        {{ content.OpenTabOnboarding1.metadata.cta }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'OpenTabOnboarding',

    data() {
      return {
        page: 1
      };
    },

    computed: {
      ...mapGetters('content', ['content'])
    },

    mounted() {
      this.mountedHandler();
    },

    beforeUnmount() {
      this.beforeDestroyHandler();
    },

    methods: {
      closeOpenTabOnboarding() {
        this.$closeModal('openTabOnboarding');
      },

      mountedHandler() {
        this.$refs.carousel.addEventListener('scroll', this.scrollHandler);
      },

      beforeDestroyHandler() {
        this.$refs.carousel.removeEventListener('scroll', this.scrollHandler);
      },

      scrollHandler() {
        const itemWidth = this.$refs.carousel.children[0].clientWidth;
        const containerWidth = this.$refs.carousel.scrollWidth;
        const scrolled = this.$refs.carousel.scrollLeft;
        const items = containerWidth / itemWidth;

        const result = ((scrolled / containerWidth) * items) + 1;

        if (Number.isInteger(result)) {
          this.page = result;
        }
      }
    }
  };
</script>

<style lang="sass">
  .onboarding__image
    width: 100%
    height: 275px
    background-repeat: no-repeat
    background-position: center top
    background-size: cover
</style>
